// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-hold-name-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.request-hold-form {
  max-height: 70vh !important;
  overflow-y: auto !important;
}
.request-hold-form .ant-picker-input input::placeholder,
.billboard-datepicker .ant-picker-input > input {
  font-size: 14px;
  color: #000 !important;
  font-family: Roboto !important;
  text-align: left !important;
  font-family: "Roboto";
  box-shadow: none;
}
.hold-expired-banner {
  width: 100%;
  background: #fcfcfc !important;
  border: 1px solid #e9e9e8 !important;
  border-radius: 6px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
.reason-txt-area .ant-input {
  font-size: 14px !important;
  color: #000 !important;
  font-family: Roboto !important;
  text-align: left !important;
  font-family: "Roboto";
  box-shadow: none;
}

.hold-expired-icon {
  width: 44px;
  height: 44px;
  background: #ffe4e6;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.hold-expired-icon .anticon {
  color: #e11d48;
  font-size: 18px;
}

.hold-expired-content {
  flex: 1 1;
}

.hold-expired-title {
  font-family: Roboto;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h5, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  align-self: stretch;
}

.hold-expired-text {
  font-family: Roboto;
  color: var(--Colors-Text-400, #3b3f3d);
  font-size: var(--Font-Font-Size-p, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 5px;
}
.hold-no-of-days-count {
  font-family: Roboto;
  color: var(--Colors-Text-500, #078552);
  font-size: var(--Font-Font-Size-h5, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.hold-days-divider {
  width: 1px;
  align-self: stretch;
  background: #d9d9d9;
}
.hold-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 30px;
  padding: 0 13px 0 7px;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 5px;
}

.hold-status-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
}

.hold-status-badge.approved {
  color: #269447;
  background: #e4f7e9;
  border: 1px solid #c7ebd0;
}

.hold-status-badge.approved .hold-status-icon {
  color: #fff;
  background: #3dbb61;
}

.hold-status-badge.in-progress {
  color: #b77900;
  background: #fff6df;
  border: 1px solid #f4dfaa;
}

.hold-status-badge.in-progress .hold-status-icon {
  color: #fff;
  background: #d99a1d;
}

.hold-status-badge.rejected {
  color: #c93636;
  background: #fdeaea;
  border: 1px solid #f3cccc;
}

.hold-status-badge.rejected .hold-status-icon {
  color: #fff;
  background: #df4b4b;
}
.hold-status-badge.expired {
  color: #c2410c;
  background: #fff1e8;
  border: 1px solid #f5c7ad;
}

.hold-status-badge.expired .hold-status-icon {
  color: #fff;
  background: #ea580c;
}
@media (max-width: 768px) {
  .hold-expired-banner {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 20px 16px;
    gap: 3px;
  }

  .hold-expired-content {
    width: 100%;
  }

  .hold-expired-title {
    font-size: 15px;
    line-height: 18px;
  }

  .hold-expired-text {
    font-size: 14px;
    line-height: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/product-request-hold-modal/ProductRequestHoldModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;;EAEE,eAAe;EACf,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".campaign-hold-name-row {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.request-hold-form {\n  max-height: 70vh !important;\n  overflow-y: auto !important;\n}\n.request-hold-form .ant-picker-input input::placeholder,\n.billboard-datepicker .ant-picker-input > input {\n  font-size: 14px;\n  color: #000 !important;\n  font-family: Roboto !important;\n  text-align: left !important;\n  font-family: \"Roboto\";\n  box-shadow: none;\n}\n.hold-expired-banner {\n  width: 100%;\n  background: #fcfcfc !important;\n  border: 1px solid #e9e9e8 !important;\n  border-radius: 6px;\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n.reason-txt-area .ant-input {\n  font-size: 14px !important;\n  color: #000 !important;\n  font-family: Roboto !important;\n  text-align: left !important;\n  font-family: \"Roboto\";\n  box-shadow: none;\n}\n\n.hold-expired-icon {\n  width: 44px;\n  height: 44px;\n  background: #ffe4e6;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.hold-expired-icon .anticon {\n  color: #e11d48;\n  font-size: 18px;\n}\n\n.hold-expired-content {\n  flex: 1;\n}\n\n.hold-expired-title {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h5, 14px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  align-self: stretch;\n}\n\n.hold-expired-text {\n  font-family: Roboto;\n  color: var(--Colors-Text-400, #3b3f3d);\n  font-size: var(--Font-Font-Size-p, 14px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  margin-bottom: 5px;\n}\n.hold-no-of-days-count {\n  font-family: Roboto;\n  color: var(--Colors-Text-500, #078552);\n  font-size: var(--Font-Font-Size-h5, 14px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n.hold-days-divider {\n  width: 1px;\n  align-self: stretch;\n  background: #d9d9d9;\n}\n.hold-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 30px;\n  padding: 0 13px 0 7px;\n  border-radius: 18px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  margin-bottom: 5px;\n}\n\n.hold-status-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.hold-status-badge.approved {\n  color: #269447;\n  background: #e4f7e9;\n  border: 1px solid #c7ebd0;\n}\n\n.hold-status-badge.approved .hold-status-icon {\n  color: #fff;\n  background: #3dbb61;\n}\n\n.hold-status-badge.in-progress {\n  color: #b77900;\n  background: #fff6df;\n  border: 1px solid #f4dfaa;\n}\n\n.hold-status-badge.in-progress .hold-status-icon {\n  color: #fff;\n  background: #d99a1d;\n}\n\n.hold-status-badge.rejected {\n  color: #c93636;\n  background: #fdeaea;\n  border: 1px solid #f3cccc;\n}\n\n.hold-status-badge.rejected .hold-status-icon {\n  color: #fff;\n  background: #df4b4b;\n}\n.hold-status-badge.expired {\n  color: #c2410c;\n  background: #fff1e8;\n  border: 1px solid #f5c7ad;\n}\n\n.hold-status-badge.expired .hold-status-icon {\n  color: #fff;\n  background: #ea580c;\n}\n@media (max-width: 768px) {\n  .hold-expired-banner {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 20px 16px;\n    gap: 3px;\n  }\n\n  .hold-expired-content {\n    width: 100%;\n  }\n\n  .hold-expired-title {\n    font-size: 15px;\n    line-height: 18px;\n  }\n\n  .hold-expired-text {\n    font-size: 14px;\n    line-height: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
